import script from "./MultiselectBase.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiselectBase.vue?vue&type=script&setup=true&lang=js"

import "./multiselectBase.scss?vue&type=style&index=0&id=670577e6&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670577e6"]])

export default __exports__